import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { compose, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import persistState from 'redux-localstorage';
import { createBrowserHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import 'flickity/css/flickity.css';

import reducers from './Reducers';
// import registerServiceWorker from './registerServiceWorker';
import App from './App';

import './LWD.css';
import './styles.css';

const history = createBrowserHistory();
const middleware = applyMiddleware(routerMiddleware(history), thunk);
let paths = null;

if (window.location.pathname.indexOf('register') === -1) {
  paths = [
    'pathway',
  ];
}

const enhancer = compose(
  middleware,
  persistState(paths),
);

const composeEnhancer = window.REDUX_DEVTOOLS_EXTENSION_COMPOSE || compose;

// const store = createStore(connectRouter(history)(reducers), composeWithDevTools(middleware), enhancer);
const store = createStore(
  connectRouter(history)(reducers),
    composeEnhancer(composeWithDevTools(middleware, enhancer)),
  // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
);

/* <Register /> */

ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>, document.getElementById('mylivewell'));

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js